import { cubicEaseOut } from '@helpers/animate';
import { Device, until } from '@helpers/media';
import SimpleImage from '@stories/Components/SimpleImage/SimpleImage';
import styled from 'styled-components';
const Container = styled.nav `
  display: block;

  @media ${until(Device.TabletLarge)} {
    margin: 0 0 28px;
  }
`;
const List = styled.ul `
  display: flex;
  align-items: center;
`;
const Item = styled.li `
  display: block;

  &:not(:last-child) {
    margin-right: 32px;
  }
`;
const Link = styled.a `
  display: block;
  color: currentColor;
  transform: scale(1);
  transition: transform 0.15s ${cubicEaseOut};

  &:focus {
    outline: none;
  }

  &:focus {
    outline: auto;
    outline-offset: 5px;
  }

  &:hover {
    transform: scale(1.2);
  }
`;
const Icon = styled(SimpleImage) `
  display: block;
  height: 37px;
  width: 37px;
`;
const SocialLinksStyles = {
    Container,
    Icon,
    Item,
    Link,
    List,
};
export default SocialLinksStyles;
